import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
    const { t } = useTranslation();

    return <div className="dark:text-white-dark text-center ltr:sm:text-left rtl:sm:text-right p-6 pt-8 mt-auto">
        <p className='inline'> © {new Date().getFullYear()}. {t('sentola_all_rights_reserved')}</p> &nbsp;
        <Link to="/partner-program/terms-and-conditions" target="_blank" rel="noopener noreferrer" className="underline hover:text-blue-500">
            {t('partner_program_terms_and_conditions')}
        </Link>
    </div>;
};

export default Footer;
